export const siteInfo = {
  name: "The Deposit Seed House",
  tagline: "Famous Fly Fishing Destination",
  shortTagline: "Furnished stays in Deposit, NY",
  phone: "917-299-6441",
  phoneHref: "tel:9172996441",
  legacyPhone: "888-222-3456",
  address: "19 Center Street, Deposit, NY 13754",
  checkIn: "1:00 PM",
  checkOut: "10:00 AM",
  youtubeUrl: "https://www.youtube.com/@DEPOSITNEWYORK/videos",
  mapUrl:
    "https://www.google.com/maps/place/19+Center+St,+Deposit,+NY+13754/data=!4m2!3m1!1s0x89db1222deaf8cf7:0x5bf345768ff408eb?sa=X&ved=1t:242&ictx=111",
  bookingSearchPath: "/search-results/",
  heroImage: "/assets/site/clean-building-image.png",
  exteriorImage: "/assets/site/clean-building-image.png",
  logo: "/assets/brand/logo-square.jpg",
};

export const buildingDescription = `The Deposit Seed House is located at 19 Center Street in the small hamlet of Deposit, New York, with convenient access to Route 17-NY (Future 86) from either direction. The property is also close to the East Branch of the Delaware River, a renowned world-class fly-fishing destination.

Each apartment is designed for business and leisure travelers, offering excellent accommodations in a warm, quiet, and secure building. Guests have access to their individual apartment, the common hallways, and the rear parking lot through both front and rear building entrances. A large rear parking area is served by two driveways and is well suited for small trailers. Guests may also use the coin-operated washers and dryers in the newly renovated basement laundry room.

Before check-in, each guest receives an access code and the house rules needed to enter their apartment.

The Deposit Seed House was originally built in 1915 by J.J. Bell as a seed-growing and packaging factory. During the 1950s, it briefly served in part as a middle school while new school construction was underway. The Seed House closed in the early 1960s and was later converted into a multi-dwelling building with several apartments. From 2020 to 2024, the entire building was gutted and renovated, creating (9) brand-new beautiful apartments for guests to choose from.

The original factory pine floors were repaired and renewed throughout the building. The property also retains its original block exterior, including all original window and door openings, preserving excellent natural light and access.

Please note: this building is not ADA-equipped.

The common hallways exhibit many interesting paintings and prints for guests to enjoy. To date, all guests have thoroughly enjoyed their stay in this unique building. We look forward to hosting you at The Deposit Seed House.

Thank you!`;

export const restaurants = [
  "Little Italy",
  "BC Pizza",
  "Butterfield's Cafe",
  "Honey's Cafe",
  "Wendy's",
  "The Country Store",
  "Chinese Restaurant",
  "The Big M supermarket",
];

export const siteHighlights = [
  {
    title: "Nine New Apartments",
    body: "Nine brand-new, beautifully renovated apartments to choose from.",
  },
  {
    title: "Rear Parking",
    body: "A large rear lot served by two driveways, with room for small trailers.",
  },
  {
    title: "Fully Furnished",
    body: "Every unit is turnkey — linens, towels, cookware, and tableware included.",
  },
  {
    title: "On-Site Laundry",
    body: "Coin-operated washers and dryers in the newly renovated basement laundry room.",
  },
  {
    title: "Private Access",
    body: "Reach your apartment, the common hallways, and the rear lot from front and rear entrances.",
  },
  {
    title: "Climate Control",
    body: "In-unit air conditioning and heat keep every apartment comfortable in any season.",
  },
];
